/**
 * Utility functions to safely access browser globals
 * These functions check if the objects exist before accessing them
 * to prevent errors during server-side rendering
 */

// Safe access to window object
export const getWindow = () => {
  return typeof window !== 'undefined' ? window : null;
};

// Safe access to location object
export const getLocation = () => {
  const win = getWindow();
  return win ? win.location : null;
};

// Safe access to process.env
export const getProcessEnv = (key) => {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  return null;
};

// Safe access to document object
export const getDocument = () => {
  return typeof document !== 'undefined' ? document : null;
};
